export function Pending() {
  return (
    <div className="min-h-svh grid place-items-center p-4">
      <Spinner className="size-10" />
    </div>
  );
}
